import { useNavigate, useSearchParams } from 'react-router-dom'
import { useOnboardingPage } from './useOnboardingPage'

export interface BaseQuestion {
  questionId: number;
}

interface UseQnAOnboardingProps<T extends BaseQuestion> {
  pageKey: string;
  questionList: T[]; // 이제 questionList는 T의 배열입니다.
  basePath: string;
  nextPageRoute: string;
}

export function useQnAOnboarding<T extends BaseQuestion>({
  pageKey,
  questionList,
  basePath,
  nextPageRoute,
}: UseQnAOnboardingProps<T>) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const {
    qaList,
    updateQaList,
    handleNext: saveAndGoToNextPage,
  } = useOnboardingPage({
    pageKey,
    nextPageRoute,
  });

  const currentQuestionId = parseInt(searchParams.get("q") || "1");

  // currentQuestion의 타입은 이제 T | undefined가 됩니다.
  const currentQuestion = questionList.find(
    (q) => q.questionId === currentQuestionId
  );

  const totalQuestions = questionList.length;

  const handleSelectAnswer = (questionId: number, answerId: number) => {
    updateQaList(questionId, answerId);

    const isLastQuestion = questionId === totalQuestions;

    setTimeout(() => {
      if (isLastQuestion) {
        saveAndGoToNextPage();
      } else {
        navigate(`${basePath}?q=${questionId + 1}`);
      }
    }, 400);
  };

  // 3. 반환되는 currentQuestion은 T 타입이므로, 어떤 질문 형태든 그대로 사용할 수 있습니다.
  return {
    currentQuestion,
    qaList,
    handleSelectAnswer,
  };
}
